import script from "./ModalEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalEdit.vue?vue&type=script&lang=ts&setup=true"

import "./ModalEdit.vue?vue&type=style&index=0&id=06e26159&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e26159"]])

export default __exports__